export default __webpack_public_path__ + "static/tablet-138b73e333208d95b965bc04b280db94.svg";